/**
 * ObjectURLField React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import TextField from '@material-ui/core/TextField';


/**
 * ObjectURLField is an editing component for URL fields of objects
 *
 * @author Jens Gruschel
 */
export class ObjectURLField extends React.Component {

    handleChange(event) {
        const value = event.target.value === "" ? undefined : event.target.value;
        this.props.onObjectValueChange(this.props.fieldDef.id, value);
    };

    validateText(acceptMissing) {
        if (this.props.value == null || this.props.value === "") {
            return acceptMissing || !this.props.fieldDef.mandatory;
        }
        else {
            return true;
        }
    }

    render() {

        const { classes, fieldDef } = this.props;

        return <TextField
            className={classes.textField}
            id={fieldDef.id}
            label={fieldDef.name}
            value={this.props.value != null ? this.props.value : ""}
            disabled={this.props.readOnly}
            required={fieldDef.mandatory}
            error={!this.validateText(true)}
            onChange={event => this.handleChange(event)}
            margin="normal"
            multiline={false}
            fullWidth={true}
            type="text"
            helperText={fieldDef.note}
            variant="standard"
            rows={this.props.rows}
            rowsMax={this.props.rows+5}
        />;
    }
}

ObjectURLField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    textField: {
        // red star for mandatory fields
        "& label span": {
            color: "#FF0000"
        }
    }
};

export default withStyles(styles)(ObjectURLField);